var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCircleGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4795 0.261078C9.1635 0.261078 0 9.44508 0 20.7611C0 32.0771 9.1635 41.2611 20.4795 41.2611C31.816 41.2611 41 32.0771 41 20.7611C41 9.44508 31.816 0.261078 20.4795 0.261078Z",
    fill: "#D4D1D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCircleGray);
export default __webpack_public_path__ + "static/media/EmptyCircleGray.b30d7129a6b42c824895f0feeba9571a.svg";
export { ForwardRef as ReactComponent };